// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AZRY","col":"styles_col__11Icn"};